import { gql } from '@apollo/client'

/**
 * Points-to-earn for the session's current cart (COM-1397).
 *
 * Fed by the `LOYALTY_POINTS` add-on through the storefront middleware
 * (COM-1398). An unopted-in storefront returns an error here, which
 * `useLoyaltyPointsPreflight` catches and renders as "hide the widget".
 *
 * ⚠️ Select only `pointsToEarn`. The backend schema also carries `total`,
 * `message`, and `historicalData`, but the cart widget uses none of them.
 * Cinnamon validates whole responses against the deployed schema, so
 * selecting a field pins this cinnamon version to a specific backend
 * deploy — fewer fields selected, fewer coupling points.
 *
 * The copy template is driven by SCS config (`texts.cart.loyaltyPointsEarned`),
 * so the backend `message` field is left alone here.
 */
const loyaltyPointsQuery = gql`
  query loyaltyPoints(
    $loyaltyPointsStorefrontName: String!
    $loyaltyPointsSessionUid: ID!
  ) {
    loyaltyPoints(
      storefrontName: $loyaltyPointsStorefrontName
      sessionUid: $loyaltyPointsSessionUid
    ) {
      pointsToEarn
    }
  }
`

export default loyaltyPointsQuery
